<div class="footer">
  @for (disclaimerItem of disclaimer; track disclaimerItem) {
    <p>{{ disclaimerItem }}</p>
  }
</div>
